import { render, staticRenderFns } from "./ModalCreateListContacts.vue?vue&type=template&id=5812fae4&scoped=true&"
import script from "./ModalCreateListContacts.vue?vue&type=script&lang=js&"
export * from "./ModalCreateListContacts.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateListContacts.vue?vue&type=style&index=0&id=5812fae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5812fae4",
  null
  
)

export default component.exports